
const quizUrl = `/spcontent/bespoke/qotw/archieml/quiz`;
const articleTemplateUrl = `/spcontent/bespoke/qotw/archieml/articletemplate.json`;
//const quizUrl = `/archieml/quiz`;

export async function fetchQuizByLink(link) {
  const res = await fetch(articleTemplateUrl);
  const data = await res.text();
  const object = JSON.parse(data);
  const q = await fetchQuiz(object[link]);
  console.log({link: q});
  return q; 
}

export async function fetchQuiz(quizId) {
  console.log('fetchQuiz');
  try {
    const res = await fetch(quizUrl + `${quizId}.json`);
    const text = await res.text();
    const value = JSON.parse(text);
    return new Promise((resolve, reject) => {
      resolve(value);
      //setTimeout(() => resolve(value), 10, value);
    });
  } catch (error) {
    return new Promise((resolve, reject) => {
      setTimeout(resolve, 10, null);
    });
  }
}

export async function fetchQuizsUntil(quizId) {
  console.log('fetchQuizsUntil');
  const all = await Promise.all(
    [...Array(quizId)].map(async (_, qi) => {
      return await fetchQuiz(qi + 1);
    })
  );
  return all;
}

export async function kdfetchQuizsUntil(quizId,InitialQuizStartNumber) {
  console.log('fetchQuizsUntil');
  const all = await Promise.all(
    [...Array(InitialQuizStartNumber-quizId+1)].map(async (_, qi) => {
      console.log("Fetching quiz", InitialQuizStartNumber-qi);
      return await fetchQuiz(InitialQuizStartNumber-qi);
    })
  );
  return all;
}

export async function fetchAllQuizs() {
  console.log('fetchAllQuizs');
  const all = [];
  let qid = 1;
  let quiz = await fetchQuiz(qid);
  while (quiz) {
    all.push(quiz);
    quiz = await fetchQuiz(++qid);
  }
  return all;
}

export function getNextQuizId(quizs) {
  console.log('getNextQuizId');
  const quizsLength = quizs.length;
  return quizsLength===0 ? 1 : quizs[quizsLength-1].id + 1
}